export default {
    graphqlApiUrl   : process.env.REACT_APP_GRAPHQL_API_URL,
    debugMode       : !!process.env.REACT_APP_DEBUG_MODE || true,
    debugUser       : process.env.REACT_APP_DEBUG_USER,
    debugPassword   : process.env.REACT_APP_DEBUG_PASSWORD,
    webshopUrl      : process.env.REACT_APP_WEBSHOP_URL || '',
    dashboardUrl    : process.env.REACT_APP_DASHBOARD_URL || '',
    freeShippingPrice    : process.env.REACT_APP_FREE_SHIPPING_PRICE || 0,
};



// WEBPACK FOOTER //
// ./src/utils/Env.ts